import React, { useContext, useEffect, useState } from 'react';
import Title from '../../components/Title/Title';
import Auxiliary from '../../util/Auxiliary';
import axios from '../../util/Api';
import { ParamsContext } from '../Context/ParamsContext';
import { Card, Col, Row } from 'antd';
import Form from './Form/Index';

const Update = (props) => {
  const [loading, setLoading] = useState(true);
  const [project, setProject] = useState({});
  const { id } = useContext(ParamsContext);

  const fetchProject = () => {
    setLoading(true);
    const url = `/project/detail?id=${id}`;
    axios.get(url).then(resp => {
      setProject(resp.data);
      setLoading(false);
    }).catch(err => {
      
    });
  }

  useEffect(() => {
    fetchProject();
  }, []);

  return (
    <Auxiliary>
      <Title>Update Proyek</Title>
      {loading ? "Sedang memuat..." : (
        <Row>
          <Col span={16}>
            <Card className="gx-card">
              <Form project={project} />
            </Card>
          </Col>
        </Row>
      )}
    </Auxiliary>
  );
}

export default Update;